"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconButtonContrastStylesHover = exports.iconButtonStylesHover = exports.IconButton = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const components_1 = require("./");
const Css_1 = require("../Css");
const useGetRef_1 = require("../hooks/useGetRef");
const utils_1 = require("../utils");
const getInteractiveElement_1 = require("../utils/getInteractiveElement");
const useTestIds_1 = require("../utils/useTestIds");
function IconButton(props) {
    const { onClick: onPress, disabled, color, icon, autoFocus, inc, buttonRef, tooltip, menuTriggerProps, openInNew, compact = false, contrast = false, download = false, forceFocusStyles = false, label, } = props;
    const isDisabled = !!disabled;
    const ariaProps = { onPress, isDisabled, autoFocus, ...menuTriggerProps };
    const ref = (0, useGetRef_1.useGetRef)(buttonRef);
    const { buttonProps } = (0, react_aria_1.useButton)({
        ...ariaProps,
        onPress: typeof onPress === "string" ? utils_1.noop : onPress,
        elementType: typeof onPress === "string" ? "a" : "button",
    }, ref);
    const { focusProps, isFocusVisible } = (0, react_aria_1.useFocusRing)(ariaProps);
    const { hoverProps, isHovered } = (0, react_aria_1.useHover)(ariaProps);
    const testIds = (0, useTestIds_1.useTestIds)(props, icon);
    const styles = (0, react_1.useMemo)(() => ({
        ...iconButtonStylesReset,
        ...(compact ? iconButtonCompact : iconButtonNormal),
        ...(isHovered && (contrast ? exports.iconButtonContrastStylesHover : exports.iconButtonStylesHover)),
        ...(isFocusVisible || forceFocusStyles ? iconButtonStylesFocus : {}),
        ...(isDisabled && iconButtonStylesDisabled),
    }), 
    // TODO: validate this eslint-disable. It was automatically ignored as part of https://app.shortcut.com/homebound-team/story/40033/enable-react-hooks-exhaustive-deps-for-react-projects
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isHovered, isFocusVisible, isDisabled, compact]);
    const iconColor = contrast ? contrastIconColor : defaultIconColor;
    const buttonAttrs = {
        ...testIds,
        ...buttonProps,
        ...focusProps,
        ...hoverProps,
        className: typeof onPress === "string" ? components_1.navLink : undefined,
        ref: ref,
        css: styles,
        "aria-label": label,
    };
    const buttonContent = ((0, jsx_runtime_1.jsx)(components_1.Icon, { icon: icon, color: color || (isDisabled ? Css_1.Palette.Gray400 : iconColor), inc: compact ? 2 : inc }));
    // If we're disabled b/c of a non-boolean ReactNode, or the caller specified tooltip text, then show it in a tooltip
    return (0, components_1.maybeTooltip)({
        title: (0, components_1.resolveTooltip)(disabled, tooltip),
        placement: "top",
        children: (0, getInteractiveElement_1.getButtonOrLink)(buttonContent, onPress, buttonAttrs, openInNew, download),
    });
}
exports.IconButton = IconButton;
const defaultIconColor = Css_1.Palette.Gray900;
const contrastIconColor = Css_1.Palette.White;
const iconButtonStylesReset = Css_1.Css.bTransparent.bsSolid.bgTransparent.cursorPointer.outline0.dif.aic.jcc.transition.$;
const iconButtonNormal = Css_1.Css.hPx(28).wPx(28).br8.bw2.$;
const iconButtonCompact = Css_1.Css.hPx(18).wPx(18).br4.bw1.$;
exports.iconButtonStylesHover = Css_1.Css.bgGray200.$;
exports.iconButtonContrastStylesHover = Css_1.Css.bgGray700.$;
const iconButtonStylesFocus = Css_1.Css.bBlue700.$;
const iconButtonStylesDisabled = Css_1.Css.cursorNotAllowed.$;
